import React, { type ReactElement, type FC } from 'react'
import { useNavigate } from '@reach/router'
import { isNil } from 'lodash'
import { t } from 'i18next'
import { useActivityStatuses } from '../../hooks/useActivityStatuses'
import { Badge } from '@awell-health/design-system'
import { ActivityStatus } from '../ActivityDetails/types'

interface IconLabelCellProps {
  label: string
  icon: ReactElement
  status?: string
  to?: string
}

export const IconLabelCell: FC<IconLabelCellProps> = ({ label, icon, status, to }): ReactElement => {
  const getBadgeKind = (): string => {
    switch (status) {
      case ActivityStatus.Active:
        return 'primary'
      case ActivityStatus.Done:
        return 'success'
      case ActivityStatus.Failed:
        return 'error'
      case ActivityStatus.Canceled:
      default:
        return 'default'
    }
  }

  const navigate = useNavigate()
  const { activityStatuses } = useActivityStatuses()

  const handleClick = (): void => {
    if (!isNil(to)) {
      void navigate(to)
    }
  }

  const statusText = activityStatuses.find(s => s.value === status)?.label ?? t('unknown')

  return (
    <div className="flex flex-row items-center justify-left gap-2">
      <div>{icon}</div>
      {isNil(to) ? (
        <span>{label}</span>
      ) : (
        <div className="cursor-pointer hover:underline text-blue-600" onClick={handleClick}>
          {label}
        </div>
      )}
      <Badge variant={getBadgeKind()}>{statusText}</Badge>
    </div>
  )
}

IconLabelCell.displayName = 'ActivityTypeIcon'
